module.exports = {"130430100":"新马头镇","130430101":"邱城镇","130430102":"梁二庄镇","130430103":"香城固镇","130430104":"古城营镇","130430201":"南辛店乡","130430204":"陈村回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130430.json
// module id = 123
// module chunks = 0